export default __webpack_public_path__ + "static/media/Halloween_BMS_cover-Image (1).0d915df0.jpg";